// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___2BjpC","default":"styles__default___Ek5Zr","medium":"styles__medium___1YpbC","large":"styles__large___1hPcf"};